import { render, staticRenderFns } from "./teamBinds.vue?vue&type=template&id=25baa2e0&scoped=true&"
import script from "./teamBinds.vue?vue&type=script&lang=js&"
export * from "./teamBinds.vue?vue&type=script&lang=js&"
import style0 from "./teamBinds.vue?vue&type=style&index=0&id=25baa2e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25baa2e0",
  null
  
)

export default component.exports